import { render, staticRenderFns } from "./partener-list.vue?vue&type=template&id=102b52a9&scoped=true&"
import script from "./partener-list.vue?vue&type=script&lang=js&"
export * from "./partener-list.vue?vue&type=script&lang=js&"
import style0 from "./partener-list.vue?vue&type=style&index=0&id=102b52a9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102b52a9",
  null
  
)

export default component.exports